import React from 'react';
import * as PropTypes from 'prop-types';
import {
  ElementWrapper,
  InputWrapper,
  TextField,
  DropdownArrow,
  DropdownWrapper,
  Option,
} from './elements';

function TxtField11B(props) {
  return (
    <ElementWrapper
      className={props.className}
      onClick={props.onClick}
      disabled={props.disabled}
    >
      <InputWrapper>
        <TextField
          placeholder={props.placeholder}
          value={props.value}
          onChange={props.onChange}
          onFocus={props.onFocus}
        />
        <DropdownArrow
          onClick={props.onIconClick}
          icon={'icon-arrow_drop_down'}
        />
      </InputWrapper>
      <DropdownWrapper visible={props.dropdownVisible}>
        {Object.entries(props.options)
          .sort((a, b) => a[1].localeCompare(b[1]))
          .map(([key, option]) => (
            <Option
              key={key}
              onClick={() => props.onDropdownItemClick({ key, option })}
            >
              {option}
            </Option>
          ))}
      </DropdownWrapper>
    </ElementWrapper>
  );
}

TxtField11B.propTypes = {
  disabled: PropTypes.bool,
  className: PropTypes.string,
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  onFocus: PropTypes.func,
  onIconClick: PropTypes.func,
  onDropdownItemClick: PropTypes.func,
  placeholder: PropTypes.string,
  value: PropTypes.node,
  dropdownVisible: PropTypes.bool,
  options: PropTypes.objectOf(PropTypes.string),
};
export default TxtField11B;
